import React, { useEffect, useState } from 'react';
import { Container, Tabs, TabPanel, HeadingText, LoadingSpinner, CaptionText } from '@paypalcorp/pp-react';
import GivingPanel from '../../ppgf/components/GivingPanel';
import GivingFooter from '../../common/components/GivingFooter';
import GivingHeader from '../../common/components/GivingHeader';
import EditProfile from '../../ppgf/components/EditProfile';
import EditSecondaryContact from '../../ppgf/components/EditSecondaryContact';
import { parseMessages } from '../../utilityHelper';
import { get, findIndex } from 'lodash';
import { show, hide, bindFPTIClicks } from '../../common/domUtils';
import { postMulitPartData } from '../../common/serviceRequest';
import * as FPT from '../../utility/fpt';
import { fireEvent } from '../../common/extendSessionUtils';
import { launchRedirect } from '../../lib/validate';
import { extendSessionAPI } from '../../common/extendSessionUtils';
import { links } from '../../../../constants/links.json';
import { BRAZIL } from '../../../../constants/constants';
import ReactHtmlParser from 'react-html-parser';

import withTheme from '../../common/withTheme';
const TabsPanel = ({ location }) => {
    const messages = parseMessages('givingfund');
    const propertyInfo = parseMessages('common/TabsPanel');
    const ppgfTabs = [{ page: 'dashboard', url: '/givingfund/dashboard' }, { page: 'activity', url: '/givingfund/activity' }, { page: 'profile', url: '/givingfund/profile' }];
    const pageDetails = JSON.parse(document.getElementById('data-page-details') && document.getElementById('data-page-details').innerHTML || '{}');
    const manualEnroll = (pageDetails.decision === 'MANUAL');
    const country = (document.getElementById("data-country") && document.getElementById("data-country").innerHTML) || "";
    const intialCharityInfo = JSON.parse(document.getElementById('data-charity-info') && document.getElementById('data-charity-info').innerHTML || '{}');
    const [charityInfo, setCharityInfo] = useState(intialCharityInfo);
    const [profileEditview, setProfileEditView] = useState('');
    const [pageIndex, setPageIndex] = useState(findIndex(ppgfTabs, (element) => element.page === pageDetails.page));
    const isBrazil = country === BRAZIL;
    let tabs = [];
    const ppfpAgreementURL = get(links, 'default.ppfpAgreement', '');
    const irishCharityRegulatorURL = get(links, 'default.irishCharityRegulator', '');
    const irishDisclaimer = propertyInfo.irishdisclaimer.replace('{ppfpAgreementURL}', ppfpAgreementURL).replace('{irishCharityRegulator}', irishCharityRegulatorURL);
    let label = pageDetails.directModel ? get(propertyInfo, 'content.ppgfireland') : get(propertyInfo, 'content.ppgf');
    let ppgfTab = { label: label, id: 'ppgfTab', panelId: 'ppgfPanel' };
    let grantsTab = { label: get(propertyInfo, 'content.grantspayments'), id: 'grantsTab', panelId: 'grantsPanel' };
    pageDetails.enrolled && tabs.push(ppgfTab);
    pageDetails.grantPayoutsEnabled && tabs.push(grantsTab);

    // Browser back/forward button handling 
    window.onpopstate = function (event) {
        event.state && setPageIndex(findIndex(ppgfTabs, (element) => element.page === event.state.page));
    }

    const handleTabSelection = (event) => {
        const id = event.target.id;
        if (id === 'ppgfTab') return;
        show('.loadingspinner', 'flex');
        launchRedirect('/givingfund/grant');
    }

    const handleProfileView = (view, btn) => {
        const updatedCharityInfo = { ...charityInfo };
        updatedCharityInfo.error = false;
        setCharityInfo(updatedCharityInfo);
        btn && FPT.trackButtonClick(btn);
        setProfileEditView(view);
    }

    const onSubmitProfileForm = async (payload) => {
        show('.loadingspinner', 'flex');
        payload._csrf = document.body.getAttribute('data-csrf');
        let formData = new FormData();
        for (let key in payload) {
            formData.append(key, payload[key]);
        }
        try {
            let response = await postMulitPartData('/givingfund/updateProfile', 'PUT', formData);
            if (response.status === 'error') {
                throw 'Error While calling api'
            } else if (response.redirectUrl) {
                launchRedirect(response.redirectUrl);
                return;
            } else if (manualEnroll){
                launchRedirect('/givingfund/profile');
                return;
            }
            fireEvent('fetchCall');
            const updatedCharityInfo = { ...charityInfo, ...response.data };
            updatedCharityInfo.error = false;
            setCharityInfo(updatedCharityInfo);
            setProfileEditView('');
            hide('.loadingspinner');
            return true;
        } catch (e) {
            const updatedCharityInfo = { ...charityInfo };
            updatedCharityInfo.error = true;
            setCharityInfo(updatedCharityInfo);
            hide('.loadingspinner');
            window.scrollTo(0, 0);
        }
    }

    const handlePPGFTabs = async (e) => {
        const index = e.target.getAttribute('data-tab-index');
        FPT.trackButtonClick(ppgfTabs[index].page);
        history.pushState({ page: ppgfTabs[index].page }, '', ppgfTabs[index].url);
        if (ppgfTabs[index].page === 'profile') {
            show('.loadingspinner', 'flex');
            try {
                await extendSessionAPI();
            } catch (e) {
                launchRedirect('/givingfund/profile');
            }
        }
        hide('.loadingspinner');
        setPageIndex(index);
    }

    const validateField = (field, errors, setValue) => {
        if (!field.value) {
            errors.push(field.name);
            setValue({ name: field.name, value: '', errorText: get(messages, 'profile.field.error.required') });
        }
    }

    useEffect(() => {
        hide('.loadingspinner');
        bindFPTIClicks();
        if (manualEnroll) history.pushState({ page: 'enroll' }, '', '/givingfund/enroll');
    }, [])

    const TabsWrapper = ({ children, manualEnroll }) => {
        if (manualEnroll) {
            return (<>{children}</>)
        } else {
            return (<>
                <Tabs name="tabContainer" selectedTabIdx="0" tabs={tabs} onClick={handleTabSelection}>
                    <TabPanel id="ppgfPanel">
                        <div id="charityNameHeader" style={{ display: 'flex', alignItems: 'center', margin: '2rem 0 3rem 0' }}>
                            <HeadingText level={1} size="lg">
                                {`${get(charityInfo, 'name', '')}`}
                            </HeadingText>
                        </div>
                        {children}
                        {pageDetails.directModel && <CaptionText>{ReactHtmlParser(irishDisclaimer)}</CaptionText>}
                    </TabPanel>
                    <TabPanel id="grantsPanel" />
                </Tabs>
                {!pageDetails.directModel && <GivingFooter />}
            </>)
        }
    }

    const renderBodyComponent = () => {
        switch (profileEditview) {
            case 'profile':
                return (<EditProfile
                    validateField={validateField}
                    onSubmitProfileForm={onSubmitProfileForm}
                    setProfileEditView={handleProfileView}
                    charityInfo={charityInfo}
                    country={country}
                    givingMessages={messages}
                    manualEnroll={manualEnroll} />);
            case 'contact':
                return (<EditSecondaryContact
                    validateField={validateField}
                    charityInfo={charityInfo}
                    onSubmitProfileForm={onSubmitProfileForm}
                    setProfileEditView={handleProfileView} />)
            default:
                return (<>
                    <TabsWrapper manualEnroll={manualEnroll}>
                        <GivingPanel
                            handleTabs={handlePPGFTabs}
                            charityInfo={charityInfo} pageIndex={pageIndex}
                            setProfileEditView={handleProfileView}
                            onSubmitProfileForm={onSubmitProfileForm}
                            isDirectModel={!!pageDetails.directModel}
                            isBrazil={isBrazil}
                            manualEnroll={manualEnroll} />
                    </TabsWrapper>
                </>)
        }
    }

    return (
        <>
            <GivingHeader directModel={pageDetails.directModel} selectedTab="ppgfPanel" />
            <Container id="tabsOuterContainer">
                <div className="loadingspinner"><LoadingSpinner size="xl" screenReaderText={messages.loading} /></div>
                {renderBodyComponent()}
            </Container>
        </>)
}

export default withTheme(TabsPanel);